import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './components/Layout.js';
import ScrollToTop from './components/ScrollToTop';
import AboutPage from './containers/AboutPage';
import FaqsPage from './containers/FaqsPage';
import FranchiseoppertunitiesPage from './containers/FranchiseoppertunitiesPage';
import HomePage from './containers/HomePage';
import InvestmentrequirementsPage from './containers/InvestmentrequirementsPage';
import ReasonstoinvestPage from './containers/ReasonstoinvestPage';
import RequestinformationPage from './containers/RequestinformationPage';
import SupportPage from './containers/SupportPage';

import './index.css';

ReactDOM.render(
	<Router>
		<Layout>
			<ScrollToTop>
				<Routes>
					<Route path="/" element={<HomePage />} />
					<Route path="/about" element={<AboutPage />} />
					<Route path="/faqs" element={<FaqsPage />} />

					<Route
						path="/franchise_oppertunities"
						element={<FranchiseoppertunitiesPage />}
					/>
					<Route
						path="/investment_requirements"
						element={<InvestmentrequirementsPage />}
					/>
					<Route path="/reasons_to_invest" element={<ReasonstoinvestPage />} />
					<Route
						path="/request_information"
						element={<RequestinformationPage />}
					/>
					<Route path="/support" element={<SupportPage />} />
				</Routes>
			</ScrollToTop>
		</Layout>
	</Router>,
	document.getElementById('root')
);
